export default __webpack_public_path__ + "static/media/signed.b5b5d163.svg";